import PropTypes from 'prop-types'
import React from 'react'
import Icon from 'components/Icon'
import { SearchIcon } from 'components/Icon/icons/search'
import { View } from 'components/View'
import Button from 'components/Button'

class HeaderSearch extends React.Component {
  render () {
    return (
      <Button
        onClick={this.props.onClick}
        name='Search'
      >
        <View
          style={{
            justifyContent: View.JUSTIFY.CENTER,
            alignItems: View.ALIGN.CENTER,
            width: '2.22em',
            height: '2.22em',
            color: '#666666',
            transition: 'color 0.125s ease-out'
          }}
        >
          <Icon
            icon={SearchIcon}
            size={Icon.SIZE.SMALLER}
          />
        </View>
      </Button>
    )
  }
}

HeaderSearch.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default HeaderSearch
